/**
 * `fabricInspections.*` wire contract — measured-on-arrival actuals for a fabric
 * item (GSM / width / shrinkage / shade), read against the item's master spec.
 * Behind `entitledProcedureFor("garment.materials")`.
 */
import { z } from "zod";
import { uuid, isoDate } from "../_common.js";

export const inspectionStatus = z.enum(["passed", "flagged", "hold"]);

export const recordInput = z.object({
  itemId: uuid,
  styleId: uuid.nullable().optional(),
  lotRef: z.string().trim().max(48).nullable().optional(),
  measuredGsm: z.number().int().min(0).max(2000).nullable().optional(),
  measuredWidthCm: z.number().int().min(0).max(1000).nullable().optional(),
  measuredShrinkageBp: z.number().int().min(0).max(10000).nullable().optional(),
  shade: z.string().trim().max(48).nullable().optional(),
  status: inspectionStatus,
  inspector: z.string().trim().max(64).nullable().optional(),
  notes: z.string().trim().max(2000).nullable().optional(),
  inspectedOn: isoDate,
});
export const recordOutput = z.object({ id: uuid });

export const getForItemInput = z.object({ itemId: uuid });

const inspectionRow = z.object({
  id: uuid,
  inspectedOn: isoDate,
  lotRef: z.string().nullable(),
  styleId: uuid.nullable(),
  measuredGsm: z.number().int().nullable(),
  measuredWidthCm: z.number().int().nullable(),
  measuredShrinkageBp: z.number().int().nullable(),
  shade: z.string().nullable(),
  status: inspectionStatus,
  inspector: z.string().nullable(),
  notes: z.string().nullable(),
  deviatesFromSpec: z.boolean(),
});
export const itemInspectionsView = z.object({
  itemId: uuid,
  master: z
    .object({
      gsm: z.number().int().nullable(),
      widthCm: z.number().int().nullable(),
      shrinkageBp: z.number().int().nullable(),
    })
    .nullable(),
  inspections: z.array(inspectionRow),
});
export const getForItemOutput = itemInspectionsView;

export type ItemInspectionsWire = z.infer<typeof itemInspectionsView>;
export type FabricInspectionStatusWire = z.infer<typeof inspectionStatus>;
